import styled from 'styled-components';
import media from '../../../styles/media.style';

export const Wrapper = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  max-width: 100vw;
  padding-right: constant(safe-area-inset-right); // less than equal iOS 11.1
  padding-left: constant(safe-area-inset-left); // less than equal iOS 11.1
  padding-right: env(safe-area-inset-right); // greater than equal iOS 11.2
  padding-left: env(safe-area-inset-left); // greater than equal iOS 11.2

  ${media.tabletP`
    padding: 25px 0;
  `};
`;

export const Container = styled.div`
  display: flex;
  width: 100%;
  margin: 0 auto;
  align-items: center;
  padding: 0 20px;
  height: 55px;

  .modal-opened & {
    opacity: 0.2;
    pointer-events: none;
  }
`;

export const Left = styled.div`
  align-items: center;
  display: inline-flex;
  width: 100px;
  cursor: pointer;
  height: 32px;
  line-height: 32px;
  ${media.tabletP`
    align-items: unset;
    display: unset;
  `};
`;

export const Center = styled.div`
  flex: 1;
  text-align: center;

  .isSublimicHome {
    display: none;
  }
`;
export const Right = styled.div`
  width: 30px;
  margin-left: 70px;
  text-align: right;
  img {
    width: 15px;
    height: 14px;
  }
  ${media.tabletP`
    img {
      width: 30px;
      height: 23px;
    }
  `};
`;

export const LogoCenter = styled.img`
  position: relative;
  width: 94px;
  height: 28px;
  top: calc((55px - 50px) / 2);

  ${media.tabletP`
    width: 188px;
    height: 55px;
  `};
`;

const Logo = styled.img`
  width: 75px;
  height: 30px;
  ${media.tabletP`
    width: 160px;
    height: 50px;
  `};
`;

export const LogoBlack = Logo.extend`
  opacity: ${({ white }) => (white ? '0' : '1')};
  transition: opacity 0.3s;
`;

export const PrevIcon = styled.img`
  width: 17px;
  height: 17px;
  margin-right: 10px;
  ${media.tabletP`
    width: 32px;
    height: 32px;
  `};
`;

export const PrevText = styled.span`
  margin-top: 5px;
  font-size: 12px;
  ${media.tabletP`
    font-size: unset;
    margin-top: 0;
  `};
`;



// WEBPACK FOOTER //
// ./src/components/SalonConsultation/GlobalNavi/GlobalNavi.style.js